import React from 'react';
import { Navigate } from 'react-router-dom';
// --- external imports ------

import AuthLoadingScreen from '~/authentication/AuthLoadingScreen';
import RegisterPage from '~/authentication/RegisterPage/RegisterPage';
import { useUserContext } from '~/authentication/UserProvider';
// --- internal imports ------

function GuardedRoute(props) {
	const user = useUserContext();

	const {
		component: Component,
		children,
		path,
	} = props;

	return (
		<RenderRoute user={user} path={path} component={Component} children={children} />
	);
}

function RenderRoute(props) {
	const { component: Component, children, user } = props;

	// Deliberately *not* latched the way `AuthRoute` is. On an auth route the
	// screen renders from its own state, so keeping it mounted across a later
	// check preserves a request in flight. Here the screen renders from
	// `tradersUserData`, and every event that starts a re-check clears that value
	// for the duration of it — so the mounted screen cannot survive the check
	// whatever this branch does, and skipping the loading screen would only fall
	// through to the redirect below and bounce a signed-in player to /login
	// mid-request. Registration is safe from the same teardown for a different
	// reason: `onAuthStateChanged` fires on sign-in and sign-out only, and nothing
	// in the register flow signs in or out until the form is done with.
	if (user?.isCheckingInitialAuthData) {
		return <AuthLoadingScreen />;
	}

	if (user?.tradersUserData) {
		if (user?.tradersUserData?.isRegistrationCompleted === false) {
			return <RegisterPage />;
		}

		return children || <Component />;
	}

	return <Navigate to="/login" replace />;
}

export default GuardedRoute;
